import * as React from 'react'

import { ProductPageData } from '@thg-commerce/enterprise-aurora-product/resolvers/ProductPage/types'
import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'
import { ProductVariantWithDescription } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/Product'
import { ProductSummaryOrder } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { TextStyling } from '@thg-commerce/gravity-theme'

import { ExternalIdentifierDisplayContainer } from './styles'

export const ExternalIdentifierDisplay = ({
  product,
  selectedVariant,
  textStyle,
  order,
}: {
  product: ProductPageData
  selectedVariant: ProductVariantWithDescription
  textStyle?: TextStyling
  order?: ProductSummaryOrder
}) => {
  const {
    showExternalIdentifierInProductSummary,
    showOnlyProductSKU,
  } = useSiteConfig()
  const externalIdentifierDisplayLabel = i18n(
    'general.externalidentifierdisplay.text',
  )

  const externalIdentifier = showOnlyProductSKU
    ? product.externalIdentifier
    : selectedVariant
    ? selectedVariant.externalIdentifier
    : product.externalIdentifier

  if (externalIdentifier && showExternalIdentifierInProductSummary) {
    return (
      <ExternalIdentifierDisplayContainer order={order} textStyle={textStyle}>
        {`${externalIdentifierDisplayLabel}${externalIdentifier}`}
      </ExternalIdentifierDisplayContainer>
    )
  }

  return null
}
